module.exports = __webpack_public_path__ + "img/第3章_2-3_孔廟謎題圖_2.jpg";